<template>
  <!-- :header-cell-style="table.center"
				:cell-style="table.center" -->
	<div id="grid-wrap">
		<div class="table-list" ref="tableList" :class="table.miniTable?'acc__mini__table':''">
			<el-table
				v-loading="table.loading || false"
				v-if="showTable"
				:key="key"
				:border="table.border || true"
				:data="formatData"
        row-key="uuid"
				:max-height="table.Maxheight"
        :header-cell-style="table.center"
        :height="table.height"
        :cell-style="table.cellFun || table.center"
				:header-cell-class-name = "table.headerCellStyle"
				:cell-class-name = "table.cellStyle"
				:show-summary="table.hasShowSummary || false"
				:summary-method="table.getSummaries"
				:span-method="table.arraySpanMethod"
				:row-class-name="table.tableRowClassName"
				@cell-mouse-leave="cellMouseLeave"
				@cell-mouse-enter="cellMouseEnter"
				@selection-change="toggleRowSelection"
				@row-click = 'handleRowClick'
        :default-expand-all = "table.defaultExpandAll || false"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
				ref="table"
        >
				<el-table-column
					v-if="table.hasSelect || false"
					type="selection"
					:selectable='table.selectable'
					class-name="selectionCheckbox"
					width="40">
				</el-table-column>
				<template v-for="item in config">
					<!-- 嵌套表头 -->
					<el-table-column
					    :fixed="item.fixed"
						v-if="item.showChild"
						:label="item.label"
						:key="item.value"
            >
						<template v-for="child in item.children" v-if="!child.isShow">

							<table-column :key="child.value" :column-data="child" v-bind="$attrs" :showOverflowTooltip = "child.showOverflowTooltip" >
								<template v-if="child.show === 'template'" slot-scope="props" :slot="child.value" >
									<slot :name="child.value" :scope="props.obj" :childConfig="child"></slot>
								</template>

							</table-column>
						</template>
					</el-table-column>
					<table-column
						v-else
						:key="item.value"
            :showOverflowTooltip = "item.showOverflowTooltip"
						:column-data="item"
						:renderHeader='table.renderHeader'
						v-bind="$attrs"
						>
						<template v-if="item.show === 'template'" slot-scope="props" :slot="item.value">
              <slot :name="item.value" :scope="props.obj"></slot>
              <span v-if="item.type == 'date'">
                {{ props.obj.row[item.value]?$formart(props.obj.row[item.value], item.dateType):'-' }}
              </span>
						</template>

					</table-column>
				</template>
				<!-- 有无操作 -->
				<template v-if="table.hasOperation || false">
					<oper-column  :column-operation="table.operation" @onHandleoperate="handleOperation"></oper-column>
				</template>
			</el-table>
			<!-- 翻页 -->
			<div
				class="table-pagination clearfix"
				v-if="table.hasShowPagination && table.data.length && showTable"
				ref="pagination">
				<el-pagination
					class="fr"
			    	@size-change="handleSizeChange"
			    	@current-change="handleCurrentChange"
			    	:current-page="table.page.pageNo"
					:page-sizes="table.page.pageSizes || default_Sizes"
			    	:page-size="table.page.pageSize"
			    	layout="total, prev, pager, next, sizes, jumper"
			    	:total="table.page.count">
			    </el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
import { debounce } from 'throttle-debounce'
import { TableColumn, OperColumn } from './column'
import { v4 as uuidv4 } from 'uuid';
export default {
	components: {
		TableColumn,
		OperColumn
	},
	props: {
		table: {
			type: Object,
			default () {
				return {
          id: "id",
          miniTable: false,
          defaultExpandAll: false,			// 是否默认展开所有行
					border: true,				// 是否带有纵向边框
					isNotSuspensionShow: true,        // 不显示悬浮效果
					stripe: true,				// 是否带有斑马纹
					loading: false,				// 是否显示加载动画
					hasSelect: false,			// 是否显示多选
					hasOperation: false,		// 是否有操作功能
					hasContextmenu: false,		// 是否有右键功能
					hasExpand: false,			// 是否有展开功能
					hasExpandAll: false,		// 是否展开所有行
					hasShowSummary: false,		// 是否显示合计行
					hasShowPagination: false,	// 是否显示分页
					Maxheight: '100%',			// Table最大高度
					key: 1,						// 渲染
					config: [{					// 表头数据
						name: 'label',
						value: 'prop',
						width: '100',
						show: 'normal',			// show：false隐藏当前列，normal常规表格列，template自定义表格列, index显示索引, selection显示多选
					}],
					operation: {				// 操作数据
						label: '操作',
						value: 'operation',
						data: []
					},
					data: [],					// 表格数据
					page: {						// 分页参数
						pageNo: 1,				// 当前页码
						pageSize: 10,			// 当前显示条数
						count: 10,				// 总数
						pageSizes:[10, 20,30, 50, 100 ,200,300]
					},
					center: {
						textAlign: 'center',
					},
					getSummaries: () => {},			// 自定义合计方法
					arraySpanMethod: () => {},		// 自定义合并行
					//tableRowClassName: () => {},	// 设置行Class
					// cellMouseEnter: ()=> {},		// 自定义鼠标移入
					// cellMouseLeave: ()=> {},		// 自定义鼠标移出
					renderHeader: ()=>{},             // 自定义渲染头部
					selectable:()=>{}           // 自定义禁用选项
 				}
			}
		},
		level: {
			type: Number,
			default: 0
		}
	},
	data () {
		return {
			resizeState: {
				width: null,
				height: null
			},
			headerHeight: '',
			tableHeight: '',
			bodyHeight: '',
			footerHeight: '',
			//tableListHeight: 'auto',
			key: '',
			scrollY: false,
      default_Sizes:[10,20,30, 50, 100, 200 , 300],
			showTable: true
		}
	},
	computed: {
		// 格式化数据源
		formatData () {
      this.table.data = this.addUUid(this.table.data)
			return this.table.data
		},
		// 表头
		config () {
			return this.table.config
		},
		// 是否有分页
		showPagination () {
			return this.table.hasShowPagination
		},
	},
	methods: {
    // 递归给tableData添加uuid
    addUUid (tableData) {
      tableData.forEach(row => {
        row.uuid = uuidv4()
        if(row.children && Array.isArray(row.children) && row.children.length > 0) {
          this.addUUid(row.children)
        }
      });
      return tableData
    },
		// 自定义表头
		// renderHeader(h,{column}) {
		// 	return column.label;
		// },
		bindEvents() {
			if (this.$refs.table && this.$refs.table.$el) {
				window.onresize = () => {
					this.debouncedUpdateLayout();
				}
			}
		},

		resizeListener () {
			if (!this.$refs.table) return;
			let shouldUpdateLayout = false;
			const el = this.$refs.table.$el;
			const { width: oldWidth, height: oldHeight } = this.resizeState;

			const width = el.offsetWidth;
			if (oldWidth !== width) {
				shouldUpdateLayout = true;
			}

			const height = el.offsetHeight;

			if (oldHeight !== height) {
				shouldUpdateLayout = true;
			}

			if (shouldUpdateLayout) {
				this.resizeState.width = width;
				this.resizeState.height = height;
				this.doLayout();
			}
		},
		// 行点击
		handleRowClick(row, column, event) {
			let datas = { row,column,event}
			this.$emit('clickRow',datas)
		},
		updateHeight () {
			if (!this.$ready) return this.$nextTick(() => this.updateHeight());
			if (this.$refs.table) {
				// console.log(this.$refs);
				const { headerWrapper, footerWrapper } = this.$refs.table.$refs;

				if (!headerWrapper) return;
				const headerHeight = this.headerHeight = headerWrapper.offsetHeight;

				const tableHeight = this.tableHeight = this.$el.clientHeight;

				const footerHeight = this.footerHeight = footerWrapper ? footerWrapper.offsetHeight : 0;

				this.bodyHeight = tableHeight - headerHeight - footerHeight + (footerWrapper ? 1 : 0);

				this.updateScrollY();
			}
		},

		updateScrollY () {
			const { headerWrapper, footerWrapper, bodyWrapper, emptyBlock } = this.$refs.table.$refs;

			if (this.$refs.table.$el && bodyWrapper) {
				const body = bodyWrapper.querySelector('.el-table__body');
				const paginationHeight = this.$refs.pagination ? this.$refs.pagination.offsetHeight : 0;

				this.scrollY = body.offsetHeight > this.bodyHeight;

				if (this.scrollY && this.table.Maxheight == undefined) {
					this.tableListHeight = this.tableHeight - (paginationHeight + 20);
				} else {
					this.tableListHeight = null;
				}
			}
		},

		setData () {
			this.$nextTick(() => this.updateScrollY());
		},

		doLayout () {
			this.updateHeight();
		},
		// 全选
		toggleRowSelection (val) {
		this.$emit('selectChange',val)
			if(this.table.toggleRowSelection){
				this.table.toggleRowSelection(val);

			}
		},
    // 用于多选表格，切换某一行的选中状态，如果使用了第二个参数，则是设置这一行选中与否（selected 为 true 则选中）
    async newToggleRowSelection(row, selected = true) {
      await this.$nextTick();
      this.$refs.table.toggleRowSelection(row, selected);
    },
    // 用于多选表格，清空用户的选择
    async clearSelection() {
      await this.$nextTick();
      this.$refs.table.clearSelection();
    },

		// 鼠标移入
		cellMouseEnter(row, column, cell, event) {
			if(this.table.cellMouseEnter) {
				this.table.cellMouseEnter(row, column, cell, event);
			}else {
				return;
			}
		},
		// 鼠标移出
		cellMouseLeave(row, column, cell, event) {
			if(this.table.cellMouseLeave) {
				this.table.cellMouseLeave(row, column, cell, event);
			}else {
				return;
			}
		},
		// 操作
		handleOperation (data) {
			this.$emit('onHandleoperate', data);
		},
		// 翻页 - 每页显示条数
		handleSizeChange (val) {
			this.$emit('onHandlePaginationChange', { pageSize: val });
		},
		// 翻页 - 当前页码
		handleCurrentChange (val) {
			this.$emit('onHandlePaginationChange', { pageNo: val });
		},

		// 滚动监听
		handlScroll() {
			if(this.table.isNotSuspensionShow) {
				return;
			}
			let elMain = document.querySelector('.el-main');
			let tableHead = document.querySelector('.el-table__header-wrapper');
			let tableBody = document.querySelector('.el-table__body');
			let scrollTop = elMain.scrollTop;
			if(scrollTop>100) {
				tableBody.style.marginTop = tableHead.clientHeight+'px';
				tableHead.style.position = 'fixed'
				tableHead.style.top = '122px'
				tableHead.style.left = '190px'
				tableHead.style.zIndex = '8'
			}else {
				tableBody.style.marginTop = '0';
				tableHead.style.position = 'relative'
				tableHead.style.top = '0'
				tableHead.style.left = '0'
				tableHead.style.zIndex = '1'

			}

		},
	},
	mounted () {
		let _ = this;
		_.bindEvents();
		_.doLayout();

		_.resizeState = {
			width: _.$el.offsetWidth,
			height: _.$el.offsetHeight
		}
		_.$ready = true;
		let elMain = document.querySelector('.el-main');
		// 开启滚动监听
		if(elMain) {
			elMain.addEventListener('scroll' , _.handlScroll)
		}

	},
	created () {
		this.debouncedUpdateLayout = debounce(50, () =>  this.doLayout());
	},
	deactivated() {
		let _ = this;
		let elMain = document.querySelector('.el-main');
		// 移出滚动监听
		if(elMain) {
			elMain.removeEventListener('scroll' , _.handlScroll)
		}
	},
	activated () {
		let _ = this;
		let elMain = document.querySelector('.el-main');
		// 开启滚动监听
		if(elMain) {
			elMain.addEventListener('scroll' , _.handlScroll)
		}
		this.$nextTick(() => {
			this.doLayout();
			this.$refs.table.doLayout();
		})
	},
	watch: {
		// table数据
		formatData: {
			immediate: true,
			handler (val) {
				if (this.$ready) {
					this.$nextTick(() => {
						this.doLayout();
						this.$refs.table.doLayout();
						this.key = this.table.key || this.key*1 + 1;
					})
				}
			}
		},
		// 表头
		config (val) {
			this.key += 1;
		},
	}
}
</script>
<style lang="less">
 	#grid-wrap {
		position: relative;
		margin-top: 0px;
		.red {
			color:red;
		}
		.el-table {
			border-radius: 5px;
			position: relative;
		}
		.success-row {
	      background: #eff9f6;
	    }
		.table-list {
			width: 100%;
			height: 100%;
		}
    .acc__mini__table {
      .cell {
        font-weight: 400;
      }
    }
		thead th, .el-table thead.is-group th, .el-table__fixed-right-patch {
			background-color: #F7F7F7;
			color: #333;
		}
		.el-table th, .el-table th.is-leaf, .el-table--border th.gutter:last-of-type {
			border-color: #EBEEF5;
		}
		.el-table--enable-row-hover .el-table__body tr:hover>td {
			background-color: #eff9f6;
		}
		.el-button--text {
			padding-top: 0;
			padding-bottom: 0;
		}
		.table-pagination {
			margin-top: 20px;
		}
		.el-table__fixed-right-patch {
			top: 1px;
		}
		.el-table__footer-wrapper tbody td, .el-table__header-wrapper tbody td, .el-table__fixed-footer-wrapper tbody td, .el-dropdown-menu__item {
			text-align: center;
		}
		/*.el-table__header-wrapper {
			position: fixed;
			top:122px;
			left:190px;
			z-index: 8888;
		}*/
		.el-table__body, .el-table__footer, .el-table__header {
			border-collapse: collapse;
		}
		.el-table__footer-wrapper tbody th {
			background-color: #f5f7fa;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/publicTable/index.vue